import { Space, Button, Input, Dropdown, Menu } from 'antd';
import { ChangeEvent, useEffect, useState } from 'react';
import { removeMember, transferMember } from '../../../../../api/studio';
import { MoreOutlined } from '@ant-design/icons';
import {
  CodeStudio,
  IAPIStudioInfo,
  IAPIStudioMemberHasPermissionItem,
  IAuditItem,
  IRbacMemberItem,
  RoleType,
} from '../../../../../model/api-modules';
import {
  IRBACRole,
  IRBACUserGroup,
  RbacRoleObjectKey,
} from '../../../../../model/rbac';
import { CommonOperateModal } from '../../common-modal';
// import { InviteFormModal } from '../../invite-modal';
import styles from '../index.module.scss';
import './style.scss';
import classNames from 'classnames';
import {
  messageError,
  messageSuccess,
} from '../../../../../components/message';
import { formatEmailName } from '../../../../../lib/email';
import { SvgIcon } from '../../../../../components/svg-icon';
import { SvgIconName } from '../../../../../components/svg-icon/model';
import inputSearch from '../../../../../assets/img/input-search.png';
import getFormatMessage from '../../../../../locales/get-format-message';
import { EditMemberDrawer } from './edit-member';
import { InviteMemberDrawer } from './invite-member';
import { IOption } from '../../organization-content';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';
import { PermissionCheck } from '../../../../component/permission-check';
import { AutoTable } from '../../../../../components/auto-table';
import { IListItem } from '../../../../../components/auto-table/model';
import { auditReadLog, auditWriteLog } from '../../../../lib/aduit-log';
// import { PermissionCheck } from '../../../../component/permission-check';
import { eventBus } from '../../../../../lib';
import { CustomPopover } from '../../../../../components/custom-popover';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly memberList: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
  readonly updateList: () => void;
  readonly onReload: () => void;
  readonly loading: boolean;
  readonly isOwner: boolean;
  readonly rolesList: ReadonlyArray<IRBACRole>;
  readonly userGroupsList: ReadonlyArray<IRBACUserGroup>;
  readonly rolesAndGroupsOptions: IOption[];
  readonly ownerUserId: string;
}

export const MemberComponent = (props: IProps) => {
  const [showInviteModal, setShowInviteModal] = useState<boolean>(false);
  const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);
  const [showTransferModal, setShowTransferModal] = useState<boolean>(false);
  const [selectRow, setSelectRow] =
    useState<IAPIStudioMemberHasPermissionItem | null>(null);
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [filterTable, setFilterTable] = useState<
    Array<IAPIStudioMemberHasPermissionItem>
  >([]);
  const [editDrawer, setEditDrawer] = useState<boolean>(false);
  const [memberList, setMemberList] = useState<
    Array<IAPIStudioMemberHasPermissionItem>
  >([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [roleGroupNames, setRoleGroupNames] = useState<string[] | null>(null);
  const [roleName, setRoleName] = useState<string | undefined>();
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const [isJustRole, setIsJustRole] = useState<boolean>(false);
  const [isOwner, setIsOwner] = useState<boolean>(
    props.isOwner ? props.isOwner : false
  );

  useEffect(() => {
    auditReadLog(IAuditItem.ViewOrganizationMembers);
  }, []);

  const showModal = () => {
    setShowInviteModal(true);
    // console.log('props.rolesList--邀请成员ok', props.rolesList);
    // console.log('props.userGroupsList--邀请成员ok', props.userGroupsList);
  };
  const onCloseFail = () => {
    setShowErrorModal(false);
  };
  const removeMemberMethods = async () => {
    if (selectRow) {
      try {
        const res = await removeMember(selectRow.StudioID, [selectRow.UserID]);
        auditWriteLog(IAuditItem.RemoveOrganizationMember, {
          detail: {
            studioID: selectRow.StudioID,
            userID: selectRow.UserID,
          },
        });
        if (res && res.code === 0) {
          messageSuccess(getFormatMessage('remove_success'));
          if (selectRow.UserID === userInfo?.UserID) {
            // 如果删除的是自己 回到选择页面
            setShowRemoveModal(false);
            window.location.href = '/studio/select-studio';
            return;
          }
          setShowRemoveModal(false);
          props.onReload();
        } else if (res.code === CodeStudio.UserRoleRemoveSelfFail) {
          /* eslint-disable */
          messageError(getFormatMessage('can_not_remove_oneself'));
          /* eslint-disable */
        } else {
          messageError(getFormatMessage('remove_fail'));
        }
      } catch (err: any) {
        messageError(err?.apiError?.message);
      }
    }
  };
  const transferMemberMethods = async () => {
    if (selectRow) {
      try {
        // console.log('当前owner用户名',props.ownerUserId);
        const res = await transferMember(
          // props.ownerUserId,
          selectRow.UserID,
          selectRow.StudioID
        );
        if (res) {
          messageSuccess(getFormatMessage('transfer_success'));
          eventBus.emit('refreshMessages');
          props.updateList();
          getMemberList();
          setShowTransferModal(false);
          return true;
        }
        messageError(getFormatMessage('transfer_fail'));
        return false;
      } catch (err: any) {
        messageError(err?.apiError?.message);
        return false;
      }
    }
    return false;
  };

  const onRemoveOk = async () => {
    if (showErrorModal) {
      return false;
    }
    removeMemberMethods();
    return true;
  };
  const TransferOk = async () => {
    transferMemberMethods();
    return true;
  };
  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value) {
      const reg = new RegExp(value, 'i');
      const arr: IAPIStudioMemberHasPermissionItem[] = [];
      memberList.forEach((item) => {
        if (
          reg.test(item.UserID) ||
          (item.UserName && reg.test(item.UserName))
        ) {
          arr.push(item);
          // arr.push(list[i]);
        }
      });
      setFilterTable(arr);
    } else {
      setFilterTable(memberList.slice());
    }
  };
  const getMemberList = () => {
    if (props.memberList && props.memberList.length > 0) {
      const newMemberList: IAPIStudioMemberHasPermissionItem[] = [];
      props.memberList.forEach((item) => {
        if (item.UserID === 'InGame_Support@tencent.com') {
          return;
        }
        newMemberList.push(item);
      });
      const selectedMember = newMemberList.find(
        (item) => item.UserID === userInfo?.UserID
      );
      // 自己 — Owner — Admin — 其他用户组;Admin及其他用户组存在多位成员时则按加入先后顺序排序
      newMemberList.sort((a, b) => {
        if (a === selectedMember) {
          return -1;
        }
        let sortNumA = 9;
        let sortNumB = 9;
        if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Owner)
        ) {
          sortNumA = 1;
        } else if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Admin)
        ) {
          sortNumA = 2;
        } else if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Editor)
        ) {
          sortNumA = 3;
        } else if (
          a.RbacMember?.some((member) => member.roleType === RoleType.Viewer)
        ) {
          sortNumA = 4;
        }
        if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Owner)
        ) {
          sortNumB = 1;
        } else if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Admin)
        ) {
          sortNumB = 2;
        } else if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Editor)
        ) {
          sortNumB = 3;
        } else if (
          b.RbacMember?.some((member) => member.roleType === RoleType.Viewer)
        ) {
          sortNumB = 4;
        }
        if (sortNumA === sortNumB) {
          const aTime = new Date(a.CreateTime).getTime();
          const bTime = new Date(b.CreateTime).getTime();
          return aTime - bTime;
        }
        return sortNumA - sortNumB;
      });

      if (selectedMember) {
        const index = newMemberList.indexOf(selectedMember);
        newMemberList.splice(index, 1);
        newMemberList.unshift(selectedMember);
      }
      setMemberList(newMemberList);
      if (selectedMember?.RbacMember?.[0]?.roleType === RoleType.Owner) {
        setIsOwner(true);
      } else {
        setIsOwner(false);
      }
      if (
        selectedMember?.RbacMember?.[0]?.roleType !== RoleType.Admin &&
        selectedMember?.RbacMember?.[0]?.roleType !== RoleType.Owner
      ) {
        setIsJustRole(true);
      }
      setFilterTable(newMemberList.slice());
    }
  };

  const getRoleGroupByUserId = (RbacMember: IRbacMemberItem[]): string[] => {
    const roleGroupNames = RbacMember?.reduce(
      (acc: string[], member: IRbacMemberItem) => {
        // 去重
        if (
          member.groupName !== '' &&
          !acc.includes(member.groupName as string)
        ) {
          acc.push(member.groupName as string);
        }
        return acc;
      },
      []
    );

    return roleGroupNames;
  };

  useEffect(() => {
    if (selectRow) {
      const roleGroups = getRoleGroupByUserId(selectRow.RbacMember);
      const roleNames = selectRow.RbacMember?.find(
        (member) => member.roleName === 'Admin' || member.roleName === 'admin'
      )?.roleName;
      setRoleName(roleNames);
      setRoleGroupNames(roleGroups);
    }
  }, [props.rolesList, props.userGroupsList, selectRow]);

  useEffect(() => {
    getMemberList();
  }, [props.memberList]);

  const COLUMNS = [
    {
      name: getFormatMessage('member_name'),
      key: 'UserName',
      tableExtension: {
        renderRow(_key: any, _value: string, row: IListItem) {
          const record = row as IAPIStudioMemberHasPermissionItem;
          if (record.UserName) {
            if (record.UserID === userInfo?.UserID) {
              return (
                <span>
                  {_value}
                  <span className="you-marker">YOU</span>
                </span>
              );
            } else {
              return <span>{_value}</span>;
            }
          } else {
            return <span>{formatEmailName(record.UserID)}</span>;
          }
        },
      },
    },
    {
      name: getFormatMessage('email_uppercase'),
      key: 'UserID',
    },
    {
      name: getFormatMessage('role_group'),
      key: 'RbacMember',
      minWith: 400,
      tableExtension: {
        renderRow(_key: any, _value: IRbacMemberItem[], row: IListItem) {
          const record = row as IAPIStudioMemberHasPermissionItem;
          if (
            record.RbacMember?.some(
              (member) => member.roleType === RoleType.Owner
            )
          ) {
            return <span>{getFormatMessage('Owner')}</span>;
          } else {
            // 自定义角色/组名称
            const roleGroupNames = getRoleGroupByUserId(_value);
            if (roleGroupNames.length === 0) {
              return (
                <span>
                  <span className="your-role">Viewer Group</span>
                </span>
              );
            }
            roleGroupNames.sort((a, b) => {
              const sortA = a === 'Admin Group' ? 1 : 0;
              const sortB = b === 'Admin Group' ? 1 : 0;
              return sortB - sortA;
            });
            return (
              <CustomPopover
                content={
                  <span>
                    {roleGroupNames?.map((name, index) => (
                      <span className="your-role" key={index}>
                        {name}
                      </span>
                    ))}
                  </span>
                }
              >
                <span>
                  {roleGroupNames?.map((name, index) => (
                    <span className="your-role" key={index}>
                      {name}
                    </span>
                  ))}
                </span>
              </CustomPopover>
            );
          }
        },
      },
    },
    {
      name: getFormatMessage('operate'),
      key: 'action',
      width: 150,
      tableExtension: {
        renderRow(_key: any, _value: string, row: IListItem) {
          const record = row as IAPIStudioMemberHasPermissionItem;
          return renderDefaultOperate(record);
        },
      },
    },
  ];

  {
    /* 需要根据owner,admin,其他角色，展示不用的内容 */
  }
  const renderDefaultOperate = (
    record: IAPIStudioMemberHasPermissionItem
  ): React.ReactNode => {
    // console.log('列表的isOwner：',isOwner);
    // 1.是owner,对admin
    if (
      isOwner &&
      record.UserID !== userInfo?.UserID &&
      record.RbacMember?.some((member) => member.roleType === RoleType.Admin)
    ) {
      // console.log('是owner,对admin');
      // 是角色
      return (
        <Space size="middle" className={classNames('operate-btn')}>
          <div className="webkit-box flex-left">
            <a
              style={{ width: 45 }}
              onClick={() => {
                setEditDrawer(true);
                setSelectRow(record);
              }}
            >
              {getFormatMessage('edit')}
            </a>
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      setShowTransferModal(true);
                      setSelectRow(record);
                    }}
                  >
                    <span>{getFormatMessage('transfer')}</span>
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      setShowRemoveModal(true);
                      setSelectRow(record);
                    }}
                  >
                    <span>{getFormatMessage('remove')}</span>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <MoreOutlined style={{ marginLeft: 10 }} />
              </a>
            </Dropdown>
          </div>
        </Space>
      );
    } else if (isJustRole && record.UserID !== userInfo?.UserID) {
      // console.log('自己是角色但是这条不是自己');
      // 2.自己如果是角色
      if (
        record.RbacMember?.every(
          (member) =>
            member.roleType !== RoleType.Owner &&
            member.roleType !== RoleType.Admin
        )
      ) {
        return (
          <Space size="middle" className={classNames('operate-btn')}>
            <div className="webkit-box flex-left">
              <PermissionCheck
                permissionKey={RbacRoleObjectKey.UserGroupCreate}
                tipsPlacement="bottomLeft"
                noPermContent={'--'}
              >
                <a
                  style={{ width: 45 }}
                  onClick={() => {
                    setEditDrawer(true);
                    setSelectRow(record);
                  }}
                >
                  {getFormatMessage('edit')}
                </a>
              </PermissionCheck>
            </div>
          </Space>
        );
      }
      return '--';
    } else if (record.UserID === userInfo?.UserID) {
      // 当前用户对自己可以移除
      return (
        <a
          className={styles.operateBtn}
          onClick={() => {
            if (isOwner && record.UserID === userInfo.UserID) {
              setShowErrorModal(true);
              return;
            }
            setShowRemoveModal(true);
            setSelectRow(record);
          }}
        >
          {getFormatMessage('remove')}
        </a>
      );
    } else if (
      !isOwner &&
      record.RbacMember?.some(
        (member) =>
          member.roleType === RoleType.Owner ||
          member.roleType === RoleType.Admin
      )
    ) {
      // 3.如果是admin 1)对onwer和其他admin不能操作
      // console.log('admin-对onwer和其他admin不能操作');
      return '--';
    } else {
      // 4.admin对角色可以编辑和移除, 5.是owner,对角色
      // console.log('admin-admin对角色可以编辑和移除，|| 是owner,对角色');
      return (
        <Space size="middle" className={classNames('operate-btn')}>
          <div className="webkit-box flex-left">
            <a
              style={{ width: 50 }}
              onClick={() => {
                setEditDrawer(true);
                setSelectRow(record);
              }}
            >
              {getFormatMessage('edit')}
            </a>
            <a
              style={{ width: 70, marginLeft: 6 }}
              onClick={() => {
                setShowRemoveModal(true);
                setSelectRow(record);
              }}
            >
              {getFormatMessage('remove')}
            </a>
          </div>
        </Space>
      );
    }
  };

  // 邀请modal
  const renderInviteModal = () => {
    if (showInviteModal) {
      return (
        <InviteMemberDrawer
          onClose={() => {
            setShowInviteModal(false);
          }}
          isJustRole={isJustRole}
          memberList={props.memberList}
          studioId={props.studioInfo.studio.StudioID}
          rolesAndGroupsOptions={props.rolesAndGroupsOptions}
          // rolesList={props.rolesList}
          // userGroupsList={props.userGroupsList}
        />
      );
    }
    return null;
  };

  // remove modal
  const renderRemoveModal = () => {
    if (showRemoveModal) {
      return (
        <CommonOperateModal
          okText={getFormatMessage('confirm')}
          okButtonProps={{
            danger: true,
          }}
          className="delete-modal member-list-modal"
          onClose={() => {
            setShowRemoveModal(false);
          }}
          onOk={onRemoveOk}
          title={getFormatMessage('remove_member')}
          context={
            <>
              {selectRow?.UserID === userInfo?.UserID ? (
                <div className="webkit-box flex-start">
                  <div>
                    {getFormatMessage('sure_quit_organization')}
                    <br />
                    {props.studioInfo.studio.Name} (
                    {props.studioInfo.studio.StudioID})?
                  </div>
                </div>
              ) : (
                <div className="webkit-box flex-start">
                  {getFormatMessage('sure_remove_member_organization', {
                    params: {
                      member:
                        selectRow?.UserName ||
                        formatEmailName(selectRow?.UserID),
                      studioName: props.studioInfo.studio.Name,
                      studioID: props.studioInfo.studio.StudioID,
                    },
                  })}
                </div>
              )}
            </>
          }
        />
      );
    }
    return null;
  };
  const onClose = (success?: boolean) => {
    setSelectRow(null);
    setEditDrawer(false);
    setRoleGroupNames(null);
    setRoleName('');
    if (success) {
      props.onReload();
    }
  };
  // edit Drawer
  const renderDrawerContent = () => {
    if (editDrawer && selectRow && roleGroupNames) {
      return (
        <EditMemberDrawer
          studioId={props.studioInfo.studio.StudioID}
          onClose={onClose}
          row={selectRow}
          roleName={roleName}
          roleGroupNames={roleGroupNames}
          rolesAndGroupsOptions={props.rolesAndGroupsOptions}
        />
      );
    }
    return null;
  };
  // transfer modal
  const renderTransferModal = () => {
    if (showTransferModal) {
      return (
        <CommonOperateModal
          okText={getFormatMessage('confirm')}
          okButtonProps={{ danger: true }}
          onClose={() => {
            setShowTransferModal(false);
          }}
          className="delete-modal member-list-modal"
          onOk={TransferOk}
          title={getFormatMessage('transfer_permission')}
          context={
            <div className="remove-text">
              {getFormatMessage('sure_transfer_permission')}
              <br />
              {selectRow?.UserName || formatEmailName(selectRow?.UserID)} (
              {selectRow?.UserID})?
              {getFormatMessage('sure_transfer_permission_desc2')}
            </div>
          }
        />
      );
    }
    return null;
  };
  // remove modal fail
  const renderRemoveFailModal = () => {
    if (showErrorModal) {
      return (
        <CommonOperateModal
          onOk={onRemoveOk}
          onClose={onCloseFail}
          title={getFormatMessage('remove_failed')}
          className="delete-modal"
          context={
            <p className="remove-text">
              {getFormatMessage('transfer_owner_role_first')}
            </p>
          }
        />
      );
    }
    return null;
  };

  // 新div为挂载容器
  const tooltipContainer = document.createElement('div');
  tooltipContainer.classList.add('custom-tooltip-container');
  document.body.appendChild(tooltipContainer);
  {
    /*需要角色判断，是其他角色禁用邀请 */
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={0}>
      <div
        className={classNames(
          'webkit-box flex-justify-space-between',
          styles.membersTitle
        )}
      >
        <div className={styles.titleLeft}>
          <PermissionCheck permissionKey={RbacRoleObjectKey.MemberInvite}>
            <Button
              onClick={showModal}
              className="gc-btn gc-btn-primary"
              icon={
                <SvgIcon
                  className="in-game-ant-icon"
                  icon={SvgIconName.InviteAddIcon}
                />
              }
            >
              <span>{getFormatMessage('invite_member')}</span>
            </Button>
          </PermissionCheck>
        </div>
        <div className="webkit-box flex-center">
          <Input
            placeholder={getFormatMessage('name_uppercase')}
            className="search-input"
            prefix={
              <img
                src={inputSearch}
                className={classNames('icon', styles.inputSearch)}
              />
            }
            onChange={onSearch}
            allowClear
            spellCheck="false"
          />
        </div>
      </div>
      <AutoTable
        loading={props.loading}
        // rowKey={(record) => record.UserID}
        list={filterTable}
        configFields={COLUMNS}
        className={styles.memberTable}
        tableExtension={{
          rowKey: 'UserID',
          pagination: {
            current: currentPage,
            total: filterTable.length,
            pageSize,
            showTotal: (total) => {
              return getFormatMessage('total_items', {
                params: {
                  total,
                },
              });
            },
          },
          onChange: (changeInfo) => {
            if (!changeInfo) {
              return;
            }
            setCurrentPage(changeInfo.current);
            setPageSize(changeInfo.pageSize || 10);
          },
        }}
      />
      {renderInviteModal()}
      {renderRemoveModal()}
      {renderTransferModal()}
      {renderRemoveFailModal()}
      {renderDrawerContent()}
    </Space>
  );
};
